/**
 * Saudi ERP — 15 modules · Arabic sidebar (مواصفات ERP السعودية)
 * href: Qawaem ERP routes (ready: true when implemented)
 */
import {
  Package,
  Briefcase,
  FolderOpen,
  Scale,
  BarChart3,
  SlidersHorizontal,
  Boxes,
  Store,
  RefreshCw,
  Lock,
  ArrowRightLeft,
  TrendingUp,
  ShoppingBag,
  BookOpen,
  FileText,
  ClipboardList,
  ClipboardCheck,
  PackageCheck,
  RotateCcw,
  AlertTriangle,
  Timer,
  Megaphone,
  GitCompare,
  Wallet,
  Receipt,
  FilePlus,
  Truck,
  CreditCard,
  AlertCircle,
  Users,
  UserPlus,
  Target,
  MessageSquare,
  Landmark,
  Book,
  FileSpreadsheet,
  Vault,
  Banknote,
  FileCheck,
  ShieldCheck,
  UserCheck,
  Building2,
  GraduationCap,
  FileSignature,
  UserX,
  Gavel,
  Award,
  Star,
  Monitor,
  FolderHeart,
  FileQuestion,
  Radio,
  Clock,
  Calendar,
  DollarSign,
  Send,
  Settings,
  UserCog,
  Building,
  LayoutDashboard,
  Columns,
  History,
  Calculator,
  Tags,
} from 'lucide-react';

/** @typedef {{ id: string, label: string, href: string, icon?: import('react').ComponentType, ready?: boolean }} SaudiSection */
/** @typedef {{ id: string, key: string, label: string, icon: import('react').ComponentType, sections: SaudiSection[] }} SaudiModule */

/** @type {SaudiModule[]} */
export const SAUDI_MODULE_STRUCTURE = [
  // ─── الوحدة 1 — إدارة الأصناف ───
  {
    id: 'articles',
    key: 'ARTICLE',
    label: 'إدارة الأصناف',
    icon: Package,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/articles/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'products', label: 'المنتجات', href: '/products', icon: Package, ready: true },
      { id: 'services', label: 'الخدمات', href: '/services', icon: Briefcase, ready: true },
      { id: 'categories', label: 'الفئات', href: '/categories', icon: FolderOpen, ready: true },
      { id: 'variants', label: 'المتغيرات', href: '/articles/variantes', icon: Columns, ready: true },
      { id: 'units', label: 'وحدات القياس', href: '/articles/unites-mesure', icon: Scale, ready: true },
      { id: 'changelog', label: 'سجل التغييرات', href: '/articles/changelog', icon: History, ready: true },
      { id: 'cost-methods', label: 'طرق التكلفة', href: '/articles/cost-methods', icon: Calculator, ready: true },
      { id: 'price-lists', label: 'قوائم الأسعار', href: '/articles/price-lists', icon: Tags, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/articles/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/articles/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 2 — إدارة المخزون ───
  {
    id: 'inventory',
    key: 'INVENTAIRE',
    label: 'إدارة المخزون',
    icon: Boxes,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/inventaire/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'warehouses', label: 'المستودعات', href: '/warehouses', icon: Store, ready: true },
      { id: 'movements', label: 'حركات المخزون', href: '/mouvements-stock', icon: RefreshCw, ready: true },
      { id: 'reservations', label: 'الحجز', href: '/inventaire/reservations', icon: Lock, ready: true },
      { id: 'transfers', label: 'التحويلات بين المستودعات', href: '/transferts', icon: ArrowRightLeft, ready: true },
      { id: 'damage-loss', label: 'التلف والفاقد', href: '/ajustements', icon: AlertTriangle, ready: true },
      { id: 'physical-inventory', label: 'الجرد الفعلي', href: '/inventaire/inventaire-physique', icon: ClipboardCheck, ready: true },
      { id: 'expiry', label: 'انتهاء الصلاحية', href: '/inventaire/lots-tracabilite', icon: Timer, ready: true },
      { id: 'valuation', label: 'تقييم المخزون', href: '/valorisation', icon: TrendingUp, ready: true },
      { id: 'reorder', label: 'إعادة الطلب', href: '/inventaire/reapprovisionnement', icon: PackageCheck, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/inventaire/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/inventaire/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 3 — إدارة المشتريات (11 أقسام §3) ───
  {
    id: 'purchasing',
    key: 'ACHATS',
    label: 'إدارة المشتريات',
    icon: ShoppingBag,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/achats/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'catalogue', label: 'فهرس الموردين', href: '/achats/catalogue', icon: BookOpen, ready: true },
      { id: 'requests', label: 'طلبات الشراء', href: '/achats/demandes', icon: FileText, ready: true },
      { id: 'orders', label: 'أوامر الشراء', href: '/achats/commandes', icon: ClipboardList, ready: true },
      { id: 'receipts', label: 'استلام البضائع', href: '/achats/receptions', icon: PackageCheck, ready: true },
      { id: 'returns', label: 'مرتجعات المشتريات', href: '/achats/retours', icon: RotateCcw, ready: true },
      { id: 'tenders', label: 'المناقصات', href: '/achats/appels-offres', icon: Megaphone, ready: true },
      { id: 'quote-comparison', label: 'مقارنة العروض', href: '/achats/comparatif-offres', icon: GitCompare, ready: true },
      { id: 'budget', label: 'ربط بالميزانية', href: '/achats/budget', icon: TrendingUp, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/achats/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/achats/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 4 — إدارة المبيعات (9 أقسام) ───
  {
    id: 'sales',
    key: 'VENTES',
    label: 'إدارة المبيعات',
    icon: TrendingUp,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/ventes/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'pricing', label: 'الأسعار والخصومات', href: '/ventes/prix-remises', icon: Tags, ready: true },
      { id: 'orders', label: 'أوامر العملاء', href: '/ventes/commandes', icon: ClipboardList, ready: true },
      { id: 'sales-book', label: 'دفتر المبيعات', href: '/ventes/livre-des-ventes', icon: BookOpen, ready: true },
      { id: 'deliveries', label: 'التسليمات', href: '/ventes/livraisons', icon: Truck, ready: true },
      { id: 'returns', label: 'مرتجعات المبيعات', href: '/ventes/retours', icon: RotateCcw, ready: true },
      { id: 'commissions', label: 'العمولات', href: '/ventes/commissions', icon: DollarSign, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/ventes/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/ventes/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 5 — إدارة الفوترة ───
  {
    id: 'billing',
    key: 'FACTURATION',
    label: 'إدارة الفوترة',
    icon: Receipt,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/facturation/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'create-doc', label: 'إنشاء مستند', href: '/document-creation', icon: FilePlus, ready: true },
      { id: 'invoices', label: 'الفواتير', href: '/facturation/factures', icon: Receipt, ready: true },
      { id: 'delivery-notes', label: 'بونات التسليم', href: '/facturation/bons-livraison', icon: Truck, ready: true },
      { id: 'payments', label: 'المدفوعات والأقساط', href: '/payments', icon: CreditCard, ready: true },
      { id: 'receivables', label: 'الذمم والمتأخرات', href: '/facturation/impayes', icon: AlertCircle, ready: true },
      { id: 'collection', label: 'متابعة التحصيل', href: '/facturation/relances', icon: MessageSquare, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/facturation/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/facturation/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 6 — CRM ───
  {
    id: 'crm',
    key: 'CRM',
    label: 'إدارة علاقات العملاء',
    icon: Users,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/crm/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'clients', label: 'العملاء', href: '/relation-client/clients', icon: UserCheck, ready: true },
      { id: 'leads', label: 'العملاء المحتملون', href: '/crm/leads', icon: UserPlus, ready: true },
      { id: 'pipeline', label: 'مسار المبيعات', href: '/crm/pipeline', icon: TrendingUp, ready: true },
      { id: 'campaigns', label: 'الحملات التسويقية', href: '/crm/campaigns', icon: Megaphone, ready: true },
      { id: 'interactions', label: 'التفاعلات والمتابعة', href: '/crm/interactions', icon: MessageSquare, ready: true },
      { id: 'goals', label: 'أهداف المبيعات', href: '/crm/sales-goals', icon: Target, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/crm/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/crm/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 7 — المحاسبة ───
  {
    id: 'accounting',
    key: 'COMPTABILITE',
    label: 'إدارة المحاسبة',
    icon: Landmark,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/comptabilite/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'entries', label: 'القيود المحاسبية', href: '/comptabilite/entries', icon: FileSpreadsheet, ready: true },
      { id: 'chart', label: 'دليل الحسابات', href: '/comptabilite/chart-accounts', icon: Book, ready: true },
      { id: 'trial-balance', label: 'ميزان المراجعة', href: '/comptabilite/balance-generale', icon: Scale, ready: true },
      { id: 'ledger', label: 'الأستاذ العام', href: '/comptabilite/grand-livre', icon: BookOpen, ready: true },
      { id: 'balance-sheet', label: 'الميزانية العمومية', href: '/comptabilite/bilan', icon: FileCheck, ready: true },
      { id: 'tax-declarations', label: 'الإقرارات الضريبية', href: '/comptabilite/tax-declarations', icon: Receipt, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/comptabilite/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/comptabilite/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 8 — الصندوق ───
  {
    id: 'cash',
    key: 'CAISSE',
    label: 'إدارة الصندوق',
    icon: Vault,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/treasury/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'journal', label: 'يومية الصندوق', href: '/treasury/journal', icon: BookOpen, ready: true },
      { id: 'main', label: 'الصندوق الرئيسي', href: '/treasury/main', icon: Vault, ready: true },
      { id: 'closure', label: 'الإقفال اليومي', href: '/treasury/closure', icon: Lock, ready: true },
      { id: 'vouchers', label: 'سندات القبض والصرف', href: '/treasury/vouchers', icon: Banknote, ready: true },
      { id: 'reconciliation', label: 'مطابقة الصندوق', href: '/treasury/reconciliation', icon: FileCheck, ready: true },
      { id: 'transfers', label: 'التحويلات النقدية', href: '/treasury/transfers', icon: ArrowRightLeft, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/treasury/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/treasury/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 9 — البنك ───
  {
    id: 'bank',
    key: 'BANQUE',
    label: 'إدارة البنك',
    icon: Landmark,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/banking/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'accounts', label: 'الحسابات البنكية', href: '/banking/accounts', icon: CreditCard, ready: true },
      { id: 'entries', label: 'القيود البنكية', href: '/banking/payment-orders', icon: FileSpreadsheet, ready: true },
      { id: 'reconciliation', label: 'التسوية البنكية', href: '/banking/reconciliation/general', icon: FileCheck, ready: true },
      { id: 'transfers', label: 'التحويلات', href: '/banking/transfers', icon: Send, ready: true },
      { id: 'checks', label: 'الشيكات', href: '/banking/checks', icon: FileText, ready: true },
      { id: 'statements', label: 'كشوف الحساب', href: '/banking/statements', icon: BookOpen, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/banking/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/banking/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 10 — الموافقات ───
  {
    id: 'approvals',
    key: 'APPROBATIONS',
    label: 'إدارة الموافقات',
    icon: ShieldCheck,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/approbations/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'my-approvals', label: 'موافقاتي', href: '/approbations/mes-approbations', icon: UserCheck, ready: true },
      { id: 'active-workflows', label: 'مسارات الاعتماد النشطة', href: '/approbations/workflows', icon: GitCompare, ready: true },
      { id: 'create-workflow', label: 'إنشاء مسار اعتماد', href: '/approbations/creer', icon: FilePlus, ready: true },
      { id: 'chain', label: 'سلسلة الاعتماد', href: '/approbations/chaine', icon: Users, ready: true },
      { id: 'statuses', label: 'حالات الطلبات', href: '/approbations/statuts', icon: ClipboardList, ready: true },
      { id: 'templates', label: 'قوالب الاعتماد', href: '/approbations/modeles', icon: FileText, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/approbations/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/approbations/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 11 — HR ───
  {
    id: 'hr',
    key: 'RESSOURCES_HUMAINES',
    label: 'إدارة الموارد البشرية',
    icon: Users,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/hr/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'employees', label: 'الموظفون', href: '/employees', icon: UserCheck, ready: true },
      { id: 'departments', label: 'الأقسام والهيكل', href: '/departments', icon: Building2, ready: true },
      { id: 'recruitment', label: 'التوظيف', href: '/hr/recruitment', icon: UserPlus, ready: true },
      { id: 'leaves', label: 'الإجازات', href: '/hr/leaves', icon: Calendar, ready: true },
      { id: 'contracts', label: 'عقود الموظفين', href: '/hr/contracts', icon: FileSignature, ready: true },
      { id: 'termination', label: 'نهاية الخدمة', href: '/hr/departures', icon: UserX, ready: true },
      { id: 'sanctions', label: 'الجزاءات', href: '/hr/sanctions', icon: Gavel, ready: true },
      { id: 'training', label: 'التدريب', href: '/hr/training', icon: GraduationCap, ready: true },
      { id: 'performance', label: 'تقييم الأداء', href: '/hr/evaluations', icon: Star, ready: true },
      { id: 'analytics', label: 'التحليلات والتقارير', href: '/hr/analyses-rapports', icon: BarChart3, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/hr/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 12 — بوابة الموظف (10 أقسام) ───
  {
    id: 'employee-portal',
    key: 'EMPLOYEE_PORTAL',
    label: 'بوابة الموظف',
    icon: Monitor,
    sections: [
      { id: 'dashboard', label: 'لوحة الموظف', href: '/employee-portal/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'profile', label: 'ملفي الشخصي', href: '/employee-portal/profile', icon: UserCheck, ready: true },
      { id: 'leaves', label: 'الإجازات', href: '/employee-portal/leaves', icon: Calendar, ready: true },
      { id: 'contracts', label: 'عقودي', href: '/employee-portal/contracts', icon: FileSignature, ready: true },
      { id: 'documents', label: 'وثائقي', href: '/employee-portal/documents', icon: FolderHeart, ready: true },
      { id: 'training', label: 'تدريبي', href: '/employee-portal/training', icon: GraduationCap, ready: true },
      { id: 'performance', label: 'تقييمي', href: '/employee-portal/performance', icon: Star, ready: true },
      { id: 'service-requests', label: 'طلبات الخدمة', href: '/employee-portal/service-requests', icon: FileQuestion, ready: true },
      { id: 'announcements', label: 'إعلانات وسياسات', href: '/employee-portal/announcements', icon: Radio, ready: true },
      { id: 'account', label: 'إعدادات الحساب', href: '/employee-portal/account', icon: Settings, ready: true },
    ],
  },

  // ─── الوحدة 13 — الحضور والانصراف (5 أقسام · بدون تحليلات) ───
  {
    id: 'attendance',
    key: 'POINTAGE',
    label: 'الحضور والانصراف',
    icon: Clock,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/timetracking/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'attendance', label: 'الحضور والانصراف', href: '/timetracking/daily', icon: Clock, ready: true },
      { id: 'overtime', label: 'الساعات الإضافية', href: '/timetracking/overtime', icon: Timer, ready: true },
      { id: 'schedules', label: 'جداول العمل والورديات', href: '/pointage/horaires-travail', icon: Calendar, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/timetracking/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 14 — الرواتب والأجور (5 أقسام · بدون تحليلات) ───
  {
    id: 'payroll',
    key: 'SALAIRES',
    label: 'الرواتب والأجور',
    icon: DollarSign,
    sections: [
      { id: 'dashboard', label: 'لوحة التحكم', href: '/salaries/dashboard', icon: LayoutDashboard, ready: true },
      { id: 'payroll', label: 'الرواتب', href: '/salaries/stats', icon: DollarSign, ready: true },
      { id: 'loans', label: 'سلف الموظفين', href: '/salaries/advances', icon: Wallet, ready: true },
      { id: 'bank-transfers', label: 'التحويلات البنكية', href: '/salaries/virements-bancaires', icon: Send, ready: true },
      { id: 'config', label: 'إعدادات الوحدة', href: '/salaries/config', icon: SlidersHorizontal, ready: true },
    ],
  },

  // ─── الوحدة 15 — إعدادات النظام ───
  {
    id: 'settings',
    key: 'PARAMETRES',
    label: 'إعدادات النظام',
    icon: Settings,
    sections: [
      { id: 'company', label: 'المنشأة والكيان القانوني', href: '/settings', icon: Building, ready: true },
      { id: 'profile', label: 'ملفي الشخصي', href: '/profile', icon: UserCog, ready: true },
      { id: 'users', label: 'إدارة المستخدمين والصلاحيات', href: '/settings/users', icon: ShieldCheck, ready: true },
    ],
  },
];

/** Lookup module + section labels for placeholder page */
export function findSaudiSection(moduleId, sectionId) {
  const mod = SAUDI_MODULE_STRUCTURE.find((m) => m.id === moduleId);
  if (!mod) return null;
  const section = mod.sections.find((s) => s.id === sectionId);
  if (!section) return null;
  return { module: mod, section };
}

export default SAUDI_MODULE_STRUCTURE;
